import { Component } from '@angular/core';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { LanguageService } from '@uigy/shared/services/language.service';
import { LicenseManagerService } from '@uigy/modules/license/license-manager.service';
import { Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { isString } from 'lodash-es';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivationCodeSource } from '@uigy/generated/graphql';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
    selector: 'app-certificate-dialog',
    templateUrl: './certificate-dialog.component.html',
    styleUrls: ['./certificate-dialog.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('100ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('250ms', style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class CertificateDialogComponent implements GenericSliderPage<{ activationCodeSource: ActivationCodeSource }, void> {
  protected readonly IconsEnum = IconsEnum;
  public dialogTexts = this.languageService.texts.license_activation.step2.slider;
  public copiedCheckMarkShown = false;
  public cert$?: Observable<string>;

  constructor(private languageService: LanguageService, private licenseManagerService: LicenseManagerService) { }

  getData(): void { }

  initData({ activationCodeSource }: { activationCodeSource: ActivationCodeSource }): void {
    this.cert$ = this.licenseManagerService.generateLicenseCertificate(activationCodeSource).pipe(
      filter(isString),
      first(),
    );
  }

  isValid(): boolean {
    return true;
  }
}
